import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Button } from '@/components/ui/button'
import { useTeam } from 'app/frontend/base/config/context/team'
import { useAuth } from 'app/frontend/base/config/context/auth'
import { useCustomDomain } from 'app/frontend/base/hooks/useCustomDomain'
import RaidPlansOverviewContent from './RaidPlansOverviewContent'
import TeamPlansIntro from './TeamPlansIntro'
import DefaultSetupCard from './default_setup/DefaultSetupCard'

const TeamPlansOverview = () => {
  const { t } = useTranslation()
  const { team } = useTeam()
  const { accessLevel } = useAuth()
  const { customDomain } = useCustomDomain()
  const canEdit = accessLevel === 'admin'

  return (
    <RaidPlansOverviewContent
      owner={{ ownerType: 'team', ownerId: team.id }}
      basePath={`${team.path}/events/plans`}
      canEdit={canEdit}
      intro={<TeamPlansIntro eventsPath={`${team.path}/events`} />}
      encounterOrders={team.encounterOrders}
      headerActions={
        customDomain?.team ? (
          <Button variant='outline' asChild>
            <Link to='/profile/plans'>
              {t('profile.plans.go-to-personal-plans')}
            </Link>
          </Button>
        ) : undefined
      }
      afterPlans={({ encounter, instance, difficulty, season }) => (
        <DefaultSetupCard
          encounter={encounter}
          instance={instance}
          difficulty={difficulty}
          season={season}
          canEdit={canEdit}
        />
      )}
    />
  )
}

export default TeamPlansOverview
